<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Products and Services</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link> /
      <router-link to="/products-services">Products and Services</router-link> /
      <b>Details</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Card -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">
              <b>Product and Services</b>
            </h4>

            <p>Fill in the information</p>

            <form class="form" @submit.prevent="handleSubmit">
              <div class="form-group" v-if="is_takaful == false">
                <label>Product and Services Name</label>
                <input
                  v-model="vendor.name"
                  class="form-control"
                  placeholder="Enter Product and Services Name"
                />
              </div>

              <div class="form-group" v-else>
                <label>Product Name</label>
                <select
                  class="form-control"
                  v-model="vendor.takaful_product_id"
                >
                  <option
                    v-for="(product, index) in takaful_products"
                    :key="index"
                    :value="product.id"
                    >{{ product.name }}</option
                  >
                </select>
              </div>

              <div class="form-group" v-if="is_takaful == true">
                <label>Discount Type</label>
                <br />
                <label class="radio-inline">
                  <label class="radio radio-warning">
                    <input
                      type="radio"
                      name="discount_type"
                      value="1"
                      v-model="vendor.discount_type"
                    />
                    <span>Percent</span>
                    <span class="checkmark"></span>
                  </label>
                </label>
                &nbsp;&nbsp;
                <label class="radio-inline">
                  <label class="radio radio-warning">
                    <input
                      type="radio"
                      name="discount_type"
                      value="2"
                      v-model="vendor.discount_type"
                      checked="true"
                    />
                    <span>Dollar</span>
                    <span class="checkmark"></span>
                  </label>
                </label>
              </div>

              <div class="form-group" v-if="is_takaful == true">
                <label>Discount Value</label>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  v-model="vendor.voucher_discount"
                  class="form-control"
                  placeholder="Enter the discount"
                />
              </div>

              <div class="form-group">
                <label>Price</label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  v-model="vendor.price"
                  class="form-control"
                  placeholder="Enter Price"
                />
              </div>

              <div class="form-group">
                <label>Quantity</label>
                <input
                  type="number"
                  min="1"
                  v-model="vendor.quantity"
                  class="form-control"
                  placeholder="Enter Quantity"
                />
              </div>

              <div class="form-group">
                <label>Description</label>
                <textarea
                  class="form-control"
                  v-model="vendor.description"
                  placeholder="Enter Description"
                >
                </textarea>
              </div>

              <div class="row">
                <div class="col-4">
                  <div class="form-group">
                    <label>Upload Image Link </label> <br />
                    <small class="text-danger">
                      (Recommended size for image 250 x 250px)</small
                    >
                    <input
                      type="file"
                      id="file"
                      ref="image"
                      v-on:change="handleFileUpload"
                      class="form-control"
                    />
                    <br />
                  </div>

                  <div class="form-group">
                    <img :src="src" />
                  </div>
                </div>

                <div class="col-4" v-if="is_takaful == false">
                  <div class="form-group">
                    <label>Promotion Duration</label>
                    <br />
                    <label class="radio-inline">
                      <label class="radio radio-warning">
                        <input
                          type="radio"
                          name="promotion"
                          value="1"
                          v-model="vendor.promotion"
                          @change="unlimited()"
                          checked
                        />
                        <span>Unlimited</span>
                        <span class="checkmark"></span>
                      </label>
                    </label>
                    &nbsp;&nbsp;
                    <label class="radio-inline">
                      <label class="radio radio-warning">
                        <input
                          type="radio"
                          name="promotion"
                          @change="limited()"
                          value="0"
                          v-model="vendor.promotion"
                        />
                        <span>Limited</span>
                        <span class="checkmark"></span>
                      </label>
                    </label>
                  </div>

                  <div id="date_duration" class="form-group">
                    <input
                      type="date"
                      class="form-control"
                      v-model="vendor.promotion_start"
                    />
                    <div class="text-center">
                      <p>to</p>
                    </div>
                    <input
                      type="date"
                      class="form-control"
                      v-model="vendor.promotion_end"
                    />
                  </div>
                </div>

                <div class="col-4" v-else>
                  <div class="form-group">
                    <label>Voucher Validity</label>
                    <br />
                    <label class="radio-inline">
                      <label class="radio radio-warning">
                        <input
                          type="radio"
                          name="duration"
                          value="6"
                          v-model="vendor.duration"
                          checked
                        />
                        <span>6 Months</span>
                        <span class="checkmark"></span>
                      </label>
                    </label>
                    &nbsp;&nbsp;
                    <label class="radio-inline">
                      <label class="radio radio-warning">
                        <input
                          type="radio"
                          name="duration"
                          value="12"
                          v-model="vendor.duration"
                        />
                        <span>12 Months</span>
                        <span class="checkmark"></span>
                      </label>
                    </label>
                  </div>
                </div>

                <div class="col-4">
                  <div class="form-group">
                    <label>Activation Status</label>
                    <br />
                    <label class="radio-inline">
                      <label class="radio radio-success">
                        <input
                          type="radio"
                          name="active"
                          value="1"
                          v-model="vendor.active"
                          checked
                        />
                        <span>Active</span>
                        <span class="checkmark"></span>
                      </label>
                    </label>
                    &nbsp;&nbsp;
                    <label class="radio-inline">
                      <label class="radio radio-danger">
                        <input
                          type="radio"
                          name="active"
                          value="0"
                          v-model="vendor.active"
                        />
                        <span>Inactive</span>
                        <span class="checkmark"></span>
                      </label>
                    </label>
                  </div>
                </div>
              </div>

              <input
                type="submit"
                class="btn btn-primary"
                value="Submit Request"
              />
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "banner_new",

  data() {
    return {
      vendor: [],

      image: "",
      src: "",
      is_takaful: false,
      takaful_products: []
    };
  },

  methods: {
    checkProfile() {
      let token = localStorage.getItem("token");
      let user = JSON.parse(localStorage.getItem("user"));

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/vendor/" + user.id, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            let vendor_data = res.data.vendor[0];
            this.takaful_products = res.data.products;

            if (vendor_data.qr_string == "qrstringtakafulbrunei") {
              this.is_takaful = true;
            }
          });
      }
    },

    handleFileUpload() {
      this.image = this.$refs.image.files[0];
    },

    handleSubmit() {
      let token = localStorage.getItem("token");
      let user = JSON.parse(localStorage.getItem("user"));
      let id = this.$route.params.id;

      if (this.vendor.promotion == 0) {
        if (
          this.vendor.promotion_start == null ||
          this.vendor.promotion_end == null ||
          this.vendor.promotion_start == "" ||
          this.vendor.promotion_end == ""
        ) {
          swal({
            icon: "warning",
            text: "Please fill in the from and end dates"
          });

          return;
        }
      }

      let fd = new FormData();
      fd.append("user_id", user.id);
      fd.append("name", this.vendor.name);
      fd.append("description", this.vendor.description);
      fd.append("price", this.vendor.price);
      fd.append("quantity", this.vendor.quantity);
      fd.append("image", this.image);
      fd.append("active", this.vendor.active);

      if (this.is_takaful == false) {
        fd.append("promotion", this.vendor.promotion);

        if (this.vendor.promotion == 0) {
          fd.append("promotion_start", this.vendor.promotion_start);
          fd.append("promotion_end", this.vendor.promotion_end);
        }
      } else {
        fd.append("duration", this.vendor.duration);
        fd.append("discount_type", this.vendor.discount_type);
        fd.append("voucher_discount", this.vendor.voucher_discount);
        fd.append("takaful_product_id", this.vendor.takaful_product_id);
      }

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        swal({
          icon: "warning",
          text: "Are you sure?",
          buttons: ["Cancel", "Yes"]
        }).then(confirm => {
          if (!confirm) {
            return;
          }

          axios
            .post(axios.lpsURL + "/vendor_product/" + id, fd, {
              headers: {
                Authorization: "Bearer " + token
              }
            })
            .then(res => {
              if (!res.data.success) {
                swal({
                  text: res.data.message,
                  icon: "warning",
                  button: "OK"
                });
              } else {
                swal({
                  text: res.data.message,
                  icon: "success",
                  button: "OK"
                });
                this.$router.push("/products-services");
              }
            });
        });
      }
    },

    loadProduct() {
      let token = localStorage.getItem("token");
      let id = this.$route.params.id;

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/vendor_product/get/" + id, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.vendor = res.data.product;

            this.loadImage(token, this.vendor.id);
          });
      }
    },

    loadImage(token, id) {
      axios
        .get(axios.lpsURL + "/vendor_product/show/" + id, {
          headers: {
            Authorization: "Bearer " + token
          },
          responseType: "blob"
        })
        .then(response => {
          let reader = new FileReader();
          reader.readAsDataURL(response.data);
          reader.onload = () => {
            this.src = reader.result;
          };
        });
    },

    unlimited() {
      $("#date_duration").addClass(" d-none");
    },

    limited() {
      $("#date_duration").removeClass("d-none");
    }
  },

  mounted() {
    this.checkProfile();
    this.loadProduct();
  }
};
</script>
